import { hasAnySubscriptionSelector } from '@repo/cf-user/selectors'
import { userQueryFetcher } from '@repo/cf-user/gen/user'
import { mapCurrencyToAvailableCurrencyCode } from '@repo/cf-user/hooks/use-user-data'
import type { CurrencyCode } from '@repo/graphql-types'
import type { PaymentsSubmitSubscriptionCheckoutMutationVariables } from '../gen/stripe'

interface SubscriptionCurrencyUser {
  stripeCustomer?: { currency?: { code?: CurrencyCode | null } | null } | null
  subscriptionAccess: Parameters<typeof hasAnySubscriptionSelector>[0] & {
    team?: { isSubscribed?: boolean }
  }
}

export function getSubscriptionCreationCurrency(user: SubscriptionCurrencyUser | null | undefined) {
  const hasSubscription =
    hasAnySubscriptionSelector(user?.subscriptionAccess) ||
    user?.subscriptionAccess.team?.isSubscribed
  return hasSubscription ? user?.stripeCustomer?.currency?.code : undefined
}

export async function withSubscriptionCreationCurrency(
  variables: PaymentsSubmitSubscriptionCheckoutMutationVariables,
): Promise<PaymentsSubmitSubscriptionCheckoutMutationVariables> {
  const data = await userQueryFetcher()().catch(() => undefined)
  const currency = getSubscriptionCreationCurrency(data?.me?.user)
  if (!currency) {
    return variables
  }

  return {
    ...variables,
    input: {
      ...variables.input,
      currencyCode: mapCurrencyToAvailableCurrencyCode(currency),
    },
  }
}
